<template>
  <div id="page">
      <Navbar :title="'Edit Link'" :backBtn="'EditInternal'"/>
      <div class="page-content header-clear-medium padding-sides">
            <div class="travel-list-container" >
                <h2 class="bold center-text" v-if="loaded">Edit {{ link.title }} Sub Link</h2>
                <div class="divider divider-margins"></div>

                <div v-if="loaded">
                <form @submit.prevent="editLink" v-if="loaded">
                
                    <ui-textbox
                        help="The Title is used purely in the backend to ease management"
                        label="Title"
                        placeholder="Enter link title"
                        v-model="link.title"
                    ></ui-textbox>

                    <ui-textbox
                        help="The PowerBI url"
                        label="Url"
                        placeholder="Enter dashboard url"
                        v-model="link.link"
                    ></ui-textbox>
                    
                    <ui-textbox
                        help="The url of the Icon to show"
                        label="Icon"
                        placeholder="Enter Icon url"
                        v-model="link.icon"
                    ></ui-textbox>

                    <ui-switch v-model="live" switch-position="right" style="padding-bottom: 20px">Live</ui-switch>
                    <p class="feedback" v-if="feedback">{{ feedback }}</p>
                    <div class="clear"></div>
                    <div class="center-allign">
                        <ui-button color="primary" :loading="loading" >Update</ui-button>
                        <ui-button
                            color="red"
                            type="secondary"
                            @click.prevent="showConfirm('deleteConfirm')"
                        >Delete</ui-button>
                    </div>
                    
                    
                </form>

                <ui-confirm
                            confirm-button-icon="delete"
                            confirm-button-text="Delete"
                            deny-button-text="Keep"
                            ref="deleteConfirm"
                            title="Delete Link"
                            type="danger"

                            @confirm="onConfirmDelete"
                            @deny="onDenyDelete"
                        >
                            Are you sure you want to delete the link?
                        </ui-confirm>
                </div>
                <div v-else class="cap-center">
                    <div class="preload-spinner preload-small border-highlight"></div>
                </div>

            </div>
        </div>
        <div class="menu-hider"></div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import Navbar from '@/components/layouts/Navbar'

export default {
    name: 'EditInternalLink',
    components:{
        Navbar
    },
    data(){
        return {
            isAdmin: false,
            link: {},
            slug: null,
            live: false,
            feedback: null,
            loading: false,
            loaded: false,
            sublinks: false,
            
        }
    },
    methods:{
        editLink(){
            this.loading = true
            if(this.link.icon && this.link.link && this.link.title){
                this.feedback = null
                //create a slug
                let status
                if (this.live){
                    status = 'live'
                } else {
                    status = 'offline'
                }
                firebase.firestore().collection('dashboards').doc('internal').collection('links').doc(this.$route.params.link_slug).collection('sub-links').doc(this.$route.params.sub_slug).update({
                    status,
                    title: this.link.title,
                    icon: this.link.icon,
                    link: this.link.link,
                }).then(() => {
                    this.feedback = 'The data has been updated successfully'
                }).catch(err => {
                    this.feedback = err
                })
            } else {
                this.feedback = 'The icon, link and title fields are compulsory'
            }
            this.loading = false
        },
         showConfirm(ref) {
            this.$refs[ref].open();
        },
        onConfirmDelete() {
           firebase.firestore().collection('dashboards').doc('internal').collection('links').doc(this.$route.params.link_slug).collection('sub-links').doc(this.$route.params.sub_slug).delete()
            .then(() => {
                this.$router.push({ name: 'EditInternalLink', params:{ link_slug: this.$route.params.link_slug }})
            }).catch(err => {
                this.feedback = err
            })
        },
        onDenyDelete() {
            console.log('You chose to keep the post.')
        }
    },
    mounted(){
        firebase.firestore().collection('dashboards').doc('internal').collection('links').doc(this.$route.params.link_slug).collection('sub-links').doc(this.$route.params.sub_slug).get()
        .then(doc => {
            this.link = doc.data()
            if (this.link.status == 'live'){
                this.live = true
            }
            this.link.sublinks ? this.sublinks = true: '' 
            this.loaded = true
        })
    }
}
</script>

<style>

</style>